import React from 'react';
import {observer} from "mobx-react";
import {BookingSearchFieldsContainerBox} from "../common/booking-search-fields-container.box";
import {BookingSearchCommonFieldsComponent} from "../common/booking-search-common-fields.component";
import {SearchByBookingDateStrategy} from "./search-by-booking-date.strategy";

import {
    DateFieldEditorWithInputMaskComponent,
    DateFieldMask
} from "../../../../components/forms/date-time/date-field-editor-with-input-mask.component";
import {
    InputFieldLabelWithTooltipComponent
} from "../../../../components/forms/input-field-label-with-tooltip/input-field-label-with-tooltip.component";
import {useServices} from "../../../../hooks/use-services.hook";

export const SearchByBookingDateComponent: React.FC<{strategy: SearchByBookingDateStrategy}> = observer((props) => {
    const services = useServices();
    const fields = props.strategy.fields;

    const renderStartDateFieldLabel = () => {
        return (
            <InputFieldLabelWithTooltipComponent field={props.strategy.fields.startDate}>
                {services.language.translationFor("Search by the date when booking was created starting with '{startDate}' until '{endDate}' (if specified) but no more than 24 hours.")
                    .withParams({
                        startDate: props.strategy.fields.startDate.fieldName,
                        endDate: props.strategy.fields.endDate.fieldName,
                    })}
            </InputFieldLabelWithTooltipComponent>
        );
    }

    const renderEndDateFieldLabel = () => {
        return (
            <InputFieldLabelWithTooltipComponent field={props.strategy.fields.endDate}>
                {props.strategy.maxEndDateMessage}
            </InputFieldLabelWithTooltipComponent>
        );
    }

    return (
        <BookingSearchFieldsContainerBox>
            <DateFieldEditorWithInputMaskComponent field={fields.startDate}
                                                   mask={DateFieldMask.DDMMYYYYhhmm}
                                                   showClearButton={true}
                                                   renderLabel={renderStartDateFieldLabel}/>
            <DateFieldEditorWithInputMaskComponent field={fields.endDate}
                                                   mask={DateFieldMask.DDMMYYYYhhmm}
                                                   showClearButton={true}
                                                   renderLabel={renderEndDateFieldLabel}/>
            <BookingSearchCommonFieldsComponent fields={fields}/>
        </BookingSearchFieldsContainerBox>
    )
})